import { render, staticRenderFns } from "./ViewAuditEthicsAndDissemination.vue?vue&type=template&id=0fa661e0&scoped=true"
import script from "./ViewAuditEthicsAndDissemination.vue?vue&type=script&lang=js"
export * from "./ViewAuditEthicsAndDissemination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa661e0",
  null
  
)

export default component.exports